import PropTypes from 'prop-types';
import {memo} from 'react';

import {
  ORDER_BY_FILTER,
  ORDER_FILTER,
  SEARCH_FILTERS,
} from '@/src/app/constants/search';
import TextLocal from '@/src/textLocal/containers/TextLocal';
import {RadioButtonCommon, SimpleCollapse, Text} from '@/src/ui';

import FilterRow from '../components/FilterRow';

const SortingFilters = ({query, setQueryFilters, withPopular}) => {
  const isOrderAscActive =
    query[SEARCH_FILTERS.ORDER] === ORDER_FILTER.ASC &&
    query[SEARCH_FILTERS.ORDER_BY] === ORDER_BY_FILTER.APPROVED_AT;

  const isOrderDescActive =
    query[SEARCH_FILTERS.ORDER] === ORDER_FILTER.DESC &&
    query[SEARCH_FILTERS.ORDER_BY] === ORDER_BY_FILTER.APPROVED_AT;

  const isOrderPopularActive =
    query[SEARCH_FILTERS.ORDER] === ORDER_FILTER.DESC &&
    query[SEARCH_FILTERS.ORDER_BY] === ORDER_BY_FILTER.AVERAGE_SCORE;

  return (
    <SimpleCollapse
      defaultIsOpen
      headTitle={
        <Text
          fontSize={Text.FONT_SIZE.SIZE_16}
          fontWeight={Text.FONT_WEIGHT.MEDIUM}
        >
          <TextLocal id={'search.sorting'} />
        </Text>
      }
    >
      <FilterRow>
        <RadioButtonCommon
          id="desc"
          type="radio"
          name="sorting"
          label={<TextLocal id={'search.sortingAsc'} />}
          checked={isOrderDescActive}
          onChange={() =>
            setQueryFilters({
              [SEARCH_FILTERS.ORDER]: ORDER_FILTER.DESC,
              [SEARCH_FILTERS.ORDER_BY]: ORDER_BY_FILTER.APPROVED_AT,
              [SEARCH_FILTERS.OFFSET]: '0',
            })
          }
        />
      </FilterRow>
      <FilterRow>
        <RadioButtonCommon
          id="asc"
          type="radio"
          name="sorting"
          label={<TextLocal id={'search.sortingDesc'} />}
          onChange={() =>
            setQueryFilters({
              [SEARCH_FILTERS.ORDER]: ORDER_FILTER.ASC,
              [SEARCH_FILTERS.ORDER_BY]: ORDER_BY_FILTER.APPROVED_AT,
              [SEARCH_FILTERS.OFFSET]: '0',
            })
          }
          checked={isOrderAscActive}
        />
      </FilterRow>
      {withPopular && (
        <FilterRow>
          <RadioButtonCommon
            id="popular"
            type="radio"
            name="sorting"
            label={<TextLocal id={'search.sortingPopular'} />}
            onChange={() =>
              setQueryFilters({
                [SEARCH_FILTERS.ORDER_BY]: ORDER_BY_FILTER.AVERAGE_SCORE,
                [SEARCH_FILTERS.ORDER]: ORDER_FILTER.DESC,
                [SEARCH_FILTERS.OFFSET]: '0',
              })
            }
            checked={isOrderPopularActive}
          />
        </FilterRow>
      )}
    </SimpleCollapse>
  );
};

SortingFilters.propTypes = {
  query: PropTypes.object.isRequired,
  setQueryFilters: PropTypes.func.isRequired,
  withPopular: PropTypes.bool,
};

SortingFilters.defaultProps = {
  withPopular: true,
};

export default memo(SortingFilters);
